"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUIRED_ERROR_FEEDBACK = exports.INVALID_EMAIL_FORMAT_FEEDBACK = exports.DROPDOWN_NO_RESULTS = void 0;
var DROPDOWN_NO_RESULTS = 'No results found.';
exports.DROPDOWN_NO_RESULTS = DROPDOWN_NO_RESULTS;
var INVALID_EMAIL_FORMAT_FEEDBACK = 'The format of the email is incorrect.';
exports.INVALID_EMAIL_FORMAT_FEEDBACK = INVALID_EMAIL_FORMAT_FEEDBACK;
var REQUIRED_ERROR_FEEDBACK = 'This field is required';
exports.REQUIRED_ERROR_FEEDBACK = REQUIRED_ERROR_FEEDBACK;